export const RESEND_COOLDOWN_MS = 60000;
export const MAX_RESEND_ATTEMPTS = 3;
export const RESET_ATTEMPTS_MS = 300000;
export const RESEND_EMAIL_REQUEST_MS = 1000;
export const RESEND_EMAIL_SUCCESS_MS = 5000;
export const NAVIGATION_DELAY_MS = 100;

export const REDIRECTION_REASONS = {
  EMAIL_CONFIRMED: 'email_confirmed',
  NO_AUTH_TOKEN: 'no_auth_token',
  ACTIVATION_SUCCESS: 'activation_success',
} as const;
